import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import SEO from "../components/SEO";

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const docsFailed = searchParams.get("docs") === "failed";

  return (
    <>
      <SEO
        title="Thank You"
        description="Thank you for your submission. A Lloyd Funding representative will be in touch shortly."
        canonical="/thank-you"
      />
      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-32">
          <div className="mx-auto max-w-xl text-center">
            {/* Checkmark Icon */}
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100">
              <svg
                className="h-10 w-10 text-emerald-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 12.75l6 6 9-13.5"
                />
              </svg>
            </div>

            <h1 className="mt-6 text-3xl font-bold text-slate-800 sm:text-4xl">
              Thank You!
            </h1>
            <p className="mt-4 text-lg text-slate-600">
              Your submission has been received successfully. One of our funding
              specialists will contact you within 24 hours.
            </p>

            {docsFailed && (
              <div className="mt-6 rounded-xl bg-amber-50 p-4 ring-1 ring-amber-200 text-left">
                <div className="flex items-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                    />
                  </svg>
                  <div>
                    <p className="text-sm font-semibold text-amber-800">
                      Your documents didn't upload successfully.
                    </p>
                    <p className="mt-1 text-sm text-amber-700">
                      Your application was received, but we didn't get your
                      documents. Please email them to{" "}
                      <a
                        href="mailto:submissions@lloydfunding.com"
                        className="font-semibold underline"
                      >
                        submissions@lloydfunding.com
                      </a>{" "}
                      or call us so we can assist you.
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-blue-600/25 hover:bg-blue-700 transition"
              >
                Back to Home
              </Link>
              <a
                href="tel:8888888888"
                className="inline-flex items-center justify-center rounded-xl bg-white px-6 py-3 text-sm font-semibold text-blue-600 ring-1 ring-blue-600 hover:bg-blue-50 transition"
              >
                Call Us Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;